if($('header').length){
    $('.responsive-tools').append($('.dropdown'))
    $('.responsive-tools').append($('header#header .header-top .navigation-buttons a[data-target="cart"]').clone());
    $('.header-top').append($('.responsive-tools'))
    $('#customerLogin input[name="email"]').attr('placeholder', '').before('<label for="email">E-mail<span>*</span></label>')
	$('#customerLogin input[name="password"]').attr('placeholder', '').before('<label for="password">Heslo<span>*</span></label>')
    $('<span class="close"></span>').appendTo('.login-widget .popup-widget-inner');    
    $(document).on("click", ".login-widget .popup-widget-inner .close", function(){
        $('body').removeClass('user-action-visible login-window-visible')
    })
    $(document).on('click', function (event) {
        var clickedElement = $(event.target);
        if (!(clickedElement.closest('.login-widget').length || clickedElement.is('a[data-target="login"]'))) {
            $('body').removeClass('login-window-visible user-action-visible');
        }
    });
    $(document).ready(function () {
        let target = 'cart';
        let timeout;
        const $cartHoverArea = $('a[data-target="cart"]');
        $cartHoverArea.on('mouseenter', function () {
            var show = (target === 'cart' && !$('a[data-target="cart"]').hasClass('full')) ? false : true;
            shoptet.popups.showPopupWindow(target, show);
        });

    });


}